import type { Tier } from "@ow/shared";
import { createContext, useContext, useEffect, useState } from "react";

interface ActiveSection {
  tier: Tier | null;
  setTier: (t: Tier | null) => void;
}

const ActiveSectionContext = createContext<ActiveSection>({ tier: null, setTier: () => {} });

/** Tracks which tier the user is currently inside (even on /search and /candidate detail
 *  pages) so the sidebar can keep that tier highlighted — preserving "you are here". */
export function ActiveSectionProvider({ children }: { children: React.ReactNode }) {
  const [tier, setTier] = useState<Tier | null>(null);
  return <ActiveSectionContext.Provider value={{ tier, setTier }}>{children}</ActiveSectionContext.Provider>;
}

export function useActiveSection() {
  return useContext(ActiveSectionContext);
}

/** Detail pages call this to light up their parent tier in the sidebar while mounted. */
export function useSetActiveSection(tier: Tier | null | undefined) {
  const { setTier } = useActiveSection();
  useEffect(() => {
    setTier(tier ?? null);
    return () => setTier(null);
  }, [tier, setTier]);
}
